import { render, staticRenderFns } from "./MonthlyNetsisScore.vue?vue&type=template&id=b2b44ee6&"
import script from "./MonthlyNetsisScore.vue?vue&type=script&lang=js&"
export * from "./MonthlyNetsisScore.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyNetsisScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports